import React from 'react';
import { useIntl } from 'react-intl';

import HelloModal from 'common/components/hello-modal';
import messages from './intl';
import Button, { ButtonType } from 'hellospa/foundation/control/button';

type Props = {
  isOpen: boolean,
  onCancel: () => void,
  onConfirm: () => void,
  confirmButtonType?: ButtonType,
}

const MeNowModal: React.FunctionComponent<Props> = ({
  isOpen,
  onCancel,
  onConfirm,
  confirmButtonType = ButtonType.Warning,
}: Props) => {
  const intl = useIntl();

  return (
    <HelloModal
      isOpen={isOpen}
      contentLabel={intl.formatMessage(messages.meNowSignerTitle)}
      showCloseIcon={false}
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      onRequestClose={onCancel}
      buttons={[
        <Button
          key="cancel"
          data-qa-ref='cancel-me-now-signer'
          kind={ButtonType.Subtle}
          onClick={onCancel}
        >
          {intl.formatMessage(messages.cancel)}
        </Button>,
        <Button
          key="confirm"
          data-qa-ref='submit-me-now-signer-confirm'
          kind={confirmButtonType}
          onClick={onConfirm}
        >
          {intl.formatMessage(messages.confirm)}
        </Button>,
      ]}
    >
      {intl.formatMessage(messages.meNowSignerContent)}
    </HelloModal>
  );
};

export default MeNowModal;
